/* eslint-disable @typescript-eslint/no-explicit-any */
import { Badge, Card, Col, Row } from "antd";
import Styles from "../../pages/operator/op.module.scss";
import Icon, { CaretRightFilled } from "@ant-design/icons";
import { PriorityIcon, ToteIcon, TrolleyIcon } from "../../assets/icons/icons";
import { getTrolleyStatus } from "./styles";
import { convertUTCToLocal } from "../../utils/timeUtils";

interface DetailsProps {
  listingType: string;
  details: {
    toteNo: number | string;
    status: string;
    totalItems: number;
    priority: boolean;
    registeredDate?: string;
    fullData?: any;
  };
  onClick?: () => void;
}

const ListingCards = ({ details, listingType, onClick }: DetailsProps) => {
  if (listingType === "Trolley") {
    const availableToteCount =
      details?.fullData?.available_totes ??
      details?.fullData?.availableTotes ??
      details?.totalItems ??
      0;
    return (
      <Card
        className="listingCards"
        onClick={onClick}
        style={{ cursor: onClick ? "pointer" : "default", overflow: "hidden" }}
      >
        <Row justify="space-between">
          <Row gutter={15}>
            {/* Left Section */}
            <Col
              className={Styles.iconBox}
              style={{ background: "#e6f3f7", flexShrink: 0 }}
            >
              <Icon component={TrolleyIcon} />
            </Col>
            <Col>
              <div className={Styles.labels}>
                Trolley ID
                <Badge
                  style={{ marginLeft: "5px" }}
                  color="#0085ad"
                  count={availableToteCount}
                />
              </div>
              <div className="values">{details?.toteNo}</div>
            </Col>
          </Row>

          <Row gutter={15} align="middle">
            {details?.priority && (
              <div className="priorityTag">
                <Icon
                  component={PriorityIcon}
                  style={{
                    color: "#ff3b30",
                    fontSize: "16px",
                    flexShrink: 0,
                  }}
                />
                <span
                  style={{
                    color: "#ff3b30",
                    fontSize: "13px",
                    fontWeight: 500,
                    whiteSpace: "nowrap",
                  }}
                >
                  Priority
                </span>
              </div>
            )}
            {onClick && (
              <Col>
                <div>
                  <CaretRightFilled
                    style={{ color: "#000", fontSize: "14px" }}
                  />
                </div>
              </Col>
            )}
          </Row>
        </Row>
        <Row className={Styles.spacingRow}>
          <Col span={14}>
            <div className={Styles.labels}>Status</div>
            <div
              style={{ color: getTrolleyStatus(details?.status) }}
              className={Styles.status}
            >
              {details?.status}
            </div>
          </Col>
          <Col span={10}>
            <div className={Styles.labels}>Available Tote(s)</div>
            <div
              style={{
                fontWeight: 400,
                fontSize: "15px",
                lineHeight: "1.5",
              }}
            >
              {availableToteCount}
            </div>
          </Col>
        </Row>
      </Card>
    );
  }

  // Tote layout (existing)
  return (
    <Card
      className="listingCards"
      onClick={onClick}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      <Row justify="space-between">
        <Row gutter={15}>
          <Col className={Styles.iconBox} style={{ background: "#e6f3f7" }}>
            <Icon component={ToteIcon} />
          </Col>
          <Col>
            <div className="labels">Tote No</div>
            <div className="values">{details?.toteNo}</div>
          </Col>
        </Row>
        <Row gutter={15} align="middle">
          {details?.priority && (
            <Col className={Styles.iconBox} style={{ background: "#FFEBEA" }}>
              <Icon component={PriorityIcon} />
            </Col>
          )}
          {onClick && (
            <Col>
              <CaretRightFilled />
            </Col>
          )}
        </Row>
      </Row>

      <Row className={Styles.spacingRow}>
        <Col span={13}>
          <div className={Styles.labels}>Status</div>
          <div
            style={{ color: getTrolleyStatus(details?.status) }}
            className={Styles.status}
          >
            {details?.status}
          </div>
        </Col>
        <Col span={11}>
          <div className={Styles.labels}>Registered Date</div>
          <div style={{ fontWeight: 600, fontSize: "14px", color: "#101010" }}>
            {details?.registeredDate
              ? convertUTCToLocal(details?.registeredDate)
              : "N/A"}
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default ListingCards;
